var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVisits(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 45,
    viewBox: "0 0 34 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1263_5694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4498 17.3312C17.6826 17.3777 17.8706 17.4102 18.0553 17.4545C19.7003 17.8473 20.8436 18.8211 21.472 20.3748C21.7191 20.9861 21.4163 21.4168 20.7518 21.4179C18.2521 21.4211 15.7524 21.4211 13.2527 21.4179C12.5859 21.4179 12.2799 20.9883 12.5269 20.3791C13.2068 18.7075 14.4593 17.7239 16.2431 17.395C16.3295 17.3788 16.4147 17.3582 16.6049 17.3171C15.7797 17.1332 15.1753 16.7783 14.749 16.167C14.3271 15.5621 14.1588 14.8924 14.291 14.1642C14.538 12.8041 15.6769 11.8671 17.0487 11.8855C18.392 11.9039 19.4926 12.8669 19.7221 14.2269C19.955 15.6011 19.1286 16.7491 17.4487 17.3323L17.4498 17.3312Z",
    fill: "#48AD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9995 27.5542C11.0973 27.5542 6.29572 22.801 6.29572 16.9582C6.29572 11.1155 11.0973 6.3623 16.9995 6.3623C22.9017 6.3623 27.7032 11.1155 27.7032 16.9582C27.7032 22.801 22.9017 27.5542 16.9995 27.5542ZM16.9995 9.17548C12.6646 9.17548 9.13752 12.6671 9.13752 16.9582C9.13752 21.2494 12.6646 24.741 16.9995 24.741C21.3343 24.741 24.8614 21.2494 24.8614 16.9582C24.8614 12.6671 21.3343 9.17548 16.9995 9.17548Z",
    fill: "#104B90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0104 45L16.0628 44.1777C15.8999 44.0359 12.0197 40.6493 8.08712 35.6235C2.72048 28.7658 0 22.4427 0 16.8282C0 7.54905 7.62587 0 16.9995 0C26.373 0 34 7.54905 34 16.8282C34 22.3074 31.2806 28.5884 25.9162 35.498C21.9868 40.5595 18.1121 44.0208 17.9493 44.1658L17.0115 45H17.0104ZM16.9995 2.81318C9.19214 2.81318 2.8418 9.10063 2.8418 16.8282C2.8418 27.04 13.68 38.0644 16.9896 41.1925C20.2905 38.0093 31.1582 26.7749 31.1582 16.8282C31.1582 9.09954 24.8068 2.81318 16.9995 2.81318Z",
    fill: "#ABABAB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1263_5694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 45,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisits);
export default __webpack_public_path__ + "static/media/icon-visits.ceb8789e967b35ebdf4d05c9fa1b367f.svg";
export { ForwardRef as ReactComponent };